<template>
  <section class="is-small">
    <layout-page-menu>
      <template #pageContent>
        <LocationMeetingtypes
          key="'meetingtypes'"
          v-if="activeMenu === 'meetingtypes'"
        />

        <LocationLanguages
          key="'languages'"
          v-if="activeMenu === 'languages'"
        />

        <LocationMailSettings
          key="'mails'"
          v-if="activeMenu === 'mails'"
        />

        <LocationTaxPercentages
          key="'taxes'"
          v-if="activeMenu === 'taxes'"
        />

        <LocationBookingTermStatus
          key="'bookingterms'"
          v-if="activeMenu === 'bookingterms'"
        />
      </template>
    </layout-page-menu>
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LocationSettings',

  components: {
    LocationLanguages: () =>
      import('@/components/Locations/Settings/LocationLanguages'),
    LocationMailSettings: () =>
      import('@/components/Locations/Settings/LocationMailSettings'),
    LocationMeetingtypes: () =>
      import('@/components/Locations/Settings/LocationMeetingtypes'),
    LocationTaxPercentages: () =>
      import('@/components/Locations/Settings/LocationTaxPercentages'),
    LocationBookingTermStatus: () =>
      import('@/components/Locations/Settings/LocationBookingTermStatus'),
  },

  props: {},

  data() {
    return {
      activeMenu: 'languages',
    }
  },

  computed: {
    ...mapState('locationStore', ['location']),

    submenuItems() {
      return [
        {
          label: 'Languages',
          view: 'languages',
        },
        {
          label: 'Meeting types',
          view: 'meetingtypes',
        },
        {
          label: 'Confirmation mail',
          view: 'mails',
        },
        {
          label: 'VAT rates',
          view: 'taxes',
        },
        {
          label: 'Booking terms',
          view: 'bookingterms',
        },
      ]
    }
  },

  provide() {
    // use function syntax so that we can access `this`
    let submenu = []
    Object.defineProperty(submenu, 'menuItems', {
      enumerable: true,
      get: () => this.submenuItems
    })

    return {
      submenu,
      selectedView: this.activeMenu,
      callbackSelectSubmenu: this.setActiveMenu
    }
  },

  created() { },

  methods: {
    setActiveMenu(submenuItem) {
      this.activeMenu = submenuItem.view
    },
  },
}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
